import React from 'react';
import { SimpleInput } from '../../../../../components/shared';

interface GdriveLinkInputProps {
  onGdriveLinkChange: (value: string) => void;
  gdriveLinkValue: string;
  isEnabled: boolean;
}

export const GdriveLinkInput: React.FC<GdriveLinkInputProps> = ({
  onGdriveLinkChange,
  gdriveLinkValue,
  isEnabled
}) => {
  return (
    <SimpleInput
      title="GDRIVE LINK"
      label="Enter GDRIVE LINK:"
      placeholder="https://drive.google.com/..."
      value={gdriveLinkValue}
      onChange={onGdriveLinkChange}
      isEnabled={isEnabled}
    />
  );
};